import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebook, FaInstagram } from "react-icons/fa";

import "./Footer.css";
import { Link } from "react-router-dom";
import { s3_url } from "common/constants";

const Footer: React.FC = () => {
  return (
    <footer className="mt-5 p-4 border-top">
      <Container>
        <Row>
          <Col md={4} className="pb-3">
            <h5>Poveznice</h5>
            <Link to="/izjava-privatnosti">Izjava o privatnosti</Link>
            <br />
            <Link to="/politika-privatnosti">Politika privatnosti</Link>
            <br />
            <Link to="/cookie-policy">Politika kolačića</Link>
            <br />
            <Link to="/opci-uvjeti">Opći uvjeti</Link>
            <br />
            <Link to="/sigurnost-placanja">
              Sigurnost plaćanja kreditmin karticama
            </Link>
          </Col>
          <Col md={4} className="pb-3">
            <h5>Društvene mreže</h5>
            <div className="social-buttons">
              <a
                href="https://www.facebook.com/lumenpoduke1"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook className="social-icon" style={{ color: "blue" }} />
              </a>
              <a
                href="https://www.instagram.com/lumenpoduke/"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram className="social-icon" />
              </a>
            </div>
          </Col>
          <Col md={4}>
            <h5>Kontakt</h5>
            <p>
              <strong>Obrt za poduke "Lumen" vl. Karmen Dasović</strong>
              <br />
              upisan u Obrtni registar Republike Hrvatske
              <br />
              <strong>OIB:</strong> 02593652259
              <br />
              Porezni broj (PDV ID): HR02593652259
              <br />
              <strong>Matični broj:</strong> 90285697
              <br />
              <strong>Email:</strong> info@lumenpoduke.com
              <br />
              <strong>Telefon:</strong> +385 098 257 119
              <br />
              <strong>Adresa:</strong> Ul. Fiorella La Guardia 12, 51000,
              Rijeka, Hrvatska
            </p>
          </Col>
        </Row>
      </Container>
      <section className="cards-payment d-flex justify-content-center">
        <div className="cards-payment-container d-flex flex-wrap justify-content-center align-items-center">
          <a href="https://www.mastercard.com" target="_blank" rel="noreferrer">
            <img
              src={`${s3_url}/img/footer/mc_vrt_opt_pos_73_3x.png`}
              alt="Mastercard logo"
            />
          </a>

          <a
            href="https://brand.mastercard.com/brandcenter/more-about-our-brands.html"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={`${s3_url}/img/footer/ms_vrt_opt_pos_73_3x.png`}
              alt="Maestro logo"
            />
          </a>

          <a
            href={`https://www.visaeurope.com`}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={`${s3_url}/img/footer/Visa 2015 50.gif`}
              alt="Visa logo"
            />
          </a>

          <img
            src={`${s3_url}/img/footer/visa-secure-blk_300dpi.jpg`}
            alt="Visa secure"
          />
          <img
            src={`${s3_url}/img/footer/mc_idcheck_hrz_rgb_pos.png`}
            alt="MC ID Check"
          />

          <a href="https://www.monri.com" target="_blank" rel="noreferrer">
            <img
              src={`${s3_url}/img/footer/monri_footer.png`}
              alt="Monri logo"
            />
          </a>
        </div>
      </section>
      <Row>
        <Col>
          <p className="mt-3 text-center">
            &copy; {new Date().getFullYear()} Lumen poduke
          </p>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
